import { useAuth0 } from '@auth0/auth0-react'
import { ReactComponent as Auth0Icon } from 'assets/icons/auth0.svg'
import { SaveButton } from 'components/ActionButton'
import config from 'config'
import { useLocation } from 'react-router'
import { RoutePath } from 'routes'
import styled from 'styled-components'

export const FormColumn = styled.div`
  grid-row: 1;
  grid-column: form;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  min-width: 23.75rem;
  align-items: stretch;
`

export const FloatingBoxFormColumn = styled(FormColumn)`
  width: 22.5rem;
  padding: 1.25rem;
  padding-top: 1.25rem;
  box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const LoginButton = (): JSX.Element => {
  const { loginWithRedirect } = useAuth0()
  const location = useLocation() as { state?: { from: { pathname: string } }; search: '' }
  const { from } = location.state || {
    from: {
      pathname: RoutePath.Root,
      search: '',
      hash: '',
    },
  }

  return (
    <>
      <Auth0Icon />
      <FloatingBoxFormColumn>
        <SaveButton
          data-testid="do-auth0"
          label={'Log in with Auth0'}
          onClick={() =>
            loginWithRedirect({
              connection: config.auth0.googleConnection,
              appState: {
                redirectUrl: from,
              },
            })
          }
        />
      </FloatingBoxFormColumn>
    </>
  )
}

export default LoginButton
